'use client'

import GenericList from './GenericList'

export default function RolesList() {
  return (
    <GenericList
      entityLabel="Role"
      initialItems={[
        { id: 'role_admin', name: 'Admin', description: 'Full access' },
        { id: 'role_user', name: 'User', description: 'Standard access' },
      ]}
    />
  )
}

